// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowBack: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M.352 6.701a.993.993 0 000 1.348l4.687 4.687a.993.993 0 001.348 0 .993.993 0 000-1.347L3.28 8.313h10.87c.527 0 .937-.41.937-.938a.926.926 0 00-.938-.938H3.281l3.106-3.076a.993.993 0 000-1.347.993.993 0 00-1.348 0L.352 6.7z" />
        </svg>
    );
};

export default React.memo(IconArrowBack);
